module.exports = __webpack_public_path__ + "img/strategy-martin.1d084d06.svg";